<template>
<div class="holder">
  <input
    :id="id"
    autocomplete="postal-code"
    :type="type"
    v-model="data"
    class="form-control"
    @input="emmitEvent"
    @keydown="emitKeydown"
    @change="emitChange"
    v-mask="'##-###'"
    :maxlength="maxlength"
    >
    <span class="counter text-muted" v-if="maxlength">{{charactersLeft}}</span>
  </div>
</template>

<script>

import Vue from "vue";

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

import IcInput from "./Input";

export default {
  name: "IcInputZip",
  extends: IcInput,
  props: {
    maxlength: { type: String, default: null },
  }

};
</script>

<style>
.holder {
  position: relative;
}
.counter {
  position: absolute;
margin-top: -34px;
right: 10px;
font-size: 70%;
}
</style>
